<template>
  <section>
    <ul class="filters-list">
      <li v-if="hasPermission('orders', 'archive_orders')">
        <router-link
          :to="{
            name: 'AllOrders',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ActiveOrders',
            query: this.$route.query,
          }"
        >
          ACTIVE
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <!-- <li>
        <router-link
          :to="{
            name: 'PartialOrders',
            query: this.$route.query,
          }"
        >
          PARTIAL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li> -->
      <!-- <li>
        <router-link
          :to="{
            name: 'FeatureOrders',
            query: this.$route.query,
          }"
        >
          FUTURE
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li> -->
      <li>
        <router-link
          :to="{
            name: 'ArchiveOrders',
            query: this.$route.query,
          }"
        >
          ARCHIVED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="hasPermission('orders', 'archive_orders')">
        <router-link
          :to="{
            name: 'CompleteOrders',
            query: this.$route.query,
          }"
        >
          FINALIZED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>

      <li v-loading="loading">
        <router-link
          :to="{
            name: 'RejectionOrders',
            query: this.$route.query,
          }"
        >
          REJECTED
          {{
            this.getOrderCounts
              ? "(" + (this.getOrderCounts.rejected_orders_count || 0) + ")"
              : "(" + "0" + ")"
          }}
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <!-- <li v-loading="loading">
        <router-link
          :to="{
            name: 'PendingOrders',
            query: this.$route.query,
          }"
        >
          PENDING
          {{
            this.getOrderCounts
              ? "(" + (this.getOrderCounts.pending_orders_count || 0) + ")"
              : "(" + "0" + ")"
          }}
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li> -->
    </ul>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
    };
  },
  mixins: [UserPermissionsHelper],

  computed: {
    ...mapGetters("orders", ["getOrderCounts"]),
  },
  mounted() {
    this.fetchAllOrdersCounts();
  },
  methods: {
    async fetchAllOrdersCounts() {
      try {
        this.loading = true;
        await this.$store.dispatch("orders/fetchOrderStats");
        this.loading = false;
      } catch (err) {}
    },
  },
};
</script>
